import stepActions from '@/screens/workflows/redux/actions/stepActions';

const handleMessage = (e) => {
  if (e.origin !== window.location.origin) {
    return;
  }
  if (e.data?.type === 'tutorial-credential') {
    const credentialId = e.data.credentialId || 'FAKE';
    stepActions.set('credentialId', credentialId);
    window.removeEventListener('message', handleMessage);
  }
};

const openTutorialAuthWindow = () => {
  const width = 500;
  const height = 600;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;
  const url = `${window.location.origin}/tutorial-auth`;
  window.open(url, 'TutorialAuth', `width=${width},height=${height},left=${left},top=${top}`);

  window.addEventListener('message', handleMessage);
};

export default openTutorialAuthWindow;
